import React from 'react';
import Hero from '../components/Hero';
import { Briefcase, Building, ShieldCheck, Globe, FileText, Scale, Users, Lightbulb } from 'lucide-react';
const Services = () => {
  return <div className="w-full" data-id="element-187">
      {/* Hero Section */}
      <Hero title="What We Do" subtitle="Comprehensive legal solutions tailored to your business needs" data-id="element-188" />
      {/* Main Content */}
      <section className="py-16 md:py-24" data-id="element-189">
        <div className="container mx-auto px-4" data-id="element-190">
          <div className="max-w-4xl mx-auto mb-16" data-id="element-191">
            <h2 className="text-3xl font-serif mb-6 text-[#1a2542]" data-id="element-192">
              Our Services
            </h2>
            <p className="text-lg text-gray-700" data-id="element-193">
              At The Concierge Lawyering, we simplify the complexities of law so
              you can focus on building and growing with confidence. Our
              services are designed to provide comprehensive legal support
              across various aspects of business and investment.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-194">
            {/* Commercial Transactions */}
            <div className="bg-white p-8 rounded-lg shadow-md border-t-4 border-[#c8a951]" data-id="element-195">
              <div className="text-[#c8a951] mb-4" data-id="element-196">
                <Briefcase size={36} data-id="element-197" />
              </div>
              <h3 className="text-xl font-serif mb-4 text-[#1a2542]" data-id="element-198">
                Commercial Transactions
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-199">
                Supporting negotiations, drafting, and deal structuring to
                safeguard your interests.
              </p>
              <ul className="text-gray-600 space-y-2" data-id="element-200">
                <li className="flex items-start" data-id="element-201">
                  <span className="text-[#c8a951] mr-2" data-id="element-202">•</span>
                  <span data-id="element-203">Contract drafting and review</span>
                </li>
                <li className="flex items-start" data-id="element-204">
                  <span className="text-[#c8a951] mr-2" data-id="element-205">•</span>
                  <span data-id="element-206">Partnership and joint venture agreements</span>
                </li>
                <li className="flex items-start" data-id="element-207">
                  <span className="text-[#c8a951] mr-2" data-id="element-208">•</span>
                  <span data-id="element-209">Mergers and acquisitions</span>
                </li>
                <li className="flex items-start" data-id="element-210">
                  <span className="text-[#c8a951] mr-2" data-id="element-211">•</span>
                  <span data-id="element-212">Business restructuring</span>
                </li>
              </ul>
            </div>
            {/* Property Transactions */}
            <div className="bg-white p-8 rounded-lg shadow-md border-t-4 border-[#c8a951]" data-id="element-213">
              <div className="text-[#c8a951] mb-4" data-id="element-214">
                <Building size={36} data-id="element-215" />
              </div>
              <h3 className="text-xl font-serif mb-4 text-[#1a2542]" data-id="element-216">
                Property Transactions
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-217">
                Managing acquisitions, leases, and transfers with clarity and
                security.
              </p>
              <ul className="text-gray-600 space-y-2" data-id="element-218">
                <li className="flex items-start" data-id="element-219">
                  <span className="text-[#c8a951] mr-2" data-id="element-220">•</span>
                  <span data-id="element-221">Real estate acquisitions and disposals</span>
                </li>
                <li className="flex items-start" data-id="element-222">
                  <span className="text-[#c8a951] mr-2" data-id="element-223">•</span>
                  <span data-id="element-224">Commercial lease agreements</span>
                </li>
                <li className="flex items-start" data-id="element-225">
                  <span className="text-[#c8a951] mr-2" data-id="element-226">•</span>
                  <span data-id="element-227">Property development and construction contracts</span>
                </li>
                <li className="flex items-start" data-id="element-228">
                  <span className="text-[#c8a951] mr-2" data-id="element-229">•</span>
                  <span data-id="element-230">Title verification and due diligence</span>
                </li>
              </ul>
            </div>
            {/* Regulatory Compliance */}
            <div className="bg-white p-8 rounded-lg shadow-md border-t-4 border-[#c8a951]" data-id="element-231">
              <div className="text-[#c8a951] mb-4" data-id="element-232">
                <ShieldCheck size={36} data-id="element-233" />
              </div>
              <h3 className="text-xl font-serif mb-4 text-[#1a2542]" data-id="element-234">
                Regulatory Compliance
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-235">
                Ensuring your business operates within the framework of local
                and international laws.
              </p>
              <ul className="text-gray-600 space-y-2" data-id="element-236">
                <li className="flex items-start" data-id="element-237">
                  <span className="text-[#c8a951] mr-2" data-id="element-238">•</span>
                  <span data-id="element-239">Corporate governance advisory</span>
                </li>
                <li className="flex items-start" data-id="element-240">
                  <span className="text-[#c8a951] mr-2" data-id="element-241">•</span>
                  <span data-id="element-242">Regulatory filings and approvals</span>
                </li>
                <li className="flex items-start" data-id="element-243">
                  <span className="text-[#c8a951] mr-2" data-id="element-244">•</span>
                  <span data-id="element-245">Compliance audits and risk assessments</span>
                </li>
                <li className="flex items-start" data-id="element-246">
                  <span className="text-[#c8a951] mr-2" data-id="element-247">•</span>
                  <span data-id="element-248">Industry-specific regulatory frameworks</span>
                </li>
              </ul>
            </div>
            {/* International Business */}
            <div className="bg-white p-8 rounded-lg shadow-md border-t-4 border-[#c8a951]" data-id="element-249">
              <div className="text-[#c8a951] mb-4" data-id="element-250">
                <Globe size={36} data-id="element-251" />
              </div>
              <h3 className="text-xl font-serif mb-4 text-[#1a2542]" data-id="element-252">
                International Business Structuring
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-253">
                Guiding cross-border ventures, particularly into Qatar and
                beyond.
              </p>
              <ul className="text-gray-600 space-y-2" data-id="element-254">
                <li className="flex items-start" data-id="element-255">
                  <span className="text-[#c8a951] mr-2" data-id="element-256">•</span>
                  <span data-id="element-257">Cross-border transaction structuring</span>
                </li>
                <li className="flex items-start" data-id="element-258">
                  <span className="text-[#c8a951] mr-2" data-id="element-259">•</span>
                  <span data-id="element-260">International entity formation</span>
                </li>
                <li className="flex items-start" data-id="element-261">
                  <span className="text-[#c8a951] mr-2" data-id="element-262">•</span>
                  <span data-id="element-263">Market entry strategies</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Approach Section */}
      <section className="py-16 md:py-24 bg-gray-50" data-id="element-264">
        <div className="container mx-auto px-4" data-id="element-265">
          <div className="max-w-4xl mx-auto" data-id="element-266">
            <h2 className="text-3xl font-serif mb-8 text-[#1a2542] text-center" data-id="element-267">
              Our Approach
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-268">
              <div data-id="element-269">
                <div className="flex items-center mb-4" data-id="element-270">
                  <div className="bg-[#1a2542] p-3 rounded-full mr-4" data-id="element-271">
                    <FileText size={24} className="text-white" data-id="element-272" />
                  </div>
                  <h3 className="text-xl font-serif text-[#1a2542]" data-id="element-273">
                    Thorough Analysis
                  </h3>
                </div>
                <p className="text-gray-600" data-id="element-274">
                  We begin by understanding your business objectives, risk
                  tolerance, and specific needs to provide tailored legal
                  solutions.
                </p>
              </div>
              <div data-id="element-275">
                <div className="flex items-center mb-4" data-id="element-276">
                  <div className="bg-[#1a2542] p-3 rounded-full mr-4" data-id="element-277">
                    <Scale size={24} className="text-white" data-id="element-278" />
                  </div>
                  <h3 className="text-xl font-serif text-[#1a2542]" data-id="element-279">
                    Strategic Advice
                  </h3>
                </div>
                <p className="text-gray-600" data-id="element-280">
                  Our recommendations balance legal requirements with practical
                  business considerations for optimal outcomes.
                </p>
              </div>
              <div data-id="element-281">
                <div className="flex items-center mb-4" data-id="element-282">
                  <div className="bg-[#1a2542] p-3 rounded-full mr-4" data-id="element-283">
                    <Users size={24} className="text-white" data-id="element-284" />
                  </div>
                  <h3 className="text-xl font-serif text-[#1a2542]" data-id="element-285">
                    Collaborative Process
                  </h3>
                </div>
                <p className="text-gray-600" data-id="element-286">
                  We work closely with your team, maintaining open communication
                  throughout the engagement.
                </p>
              </div>
              <div data-id="element-287">
                <div className="flex items-center mb-4" data-id="element-288">
                  <div className="bg-[#1a2542] p-3 rounded-full mr-4" data-id="element-289">
                    <Lightbulb size={24} className="text-white" data-id="element-290" />
                  </div>
                  <h3 className="text-xl font-serif text-[#1a2542]" data-id="element-291">
                    Innovative Solutions
                  </h3>
                </div>
                <p className="text-gray-600" data-id="element-292">
                  We leverage our expertise to develop creative approaches to
                  complex legal challenges.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default Services;